export const SEARCH_HIT_IMAGE_SIZE = 120;
export const SEARCH_HIT_IMAGE_SIZE_SMALL = 80;

export const SEARCH_HIT_SIDEBAR_IMAGE_WIDTH = 85;
export const SEARCH_HIT_SIDEBAR_IMAGE_HEIGHT = 80;
